/* ─────────────────────────────────────────────────────────────────────
   Tykables 7.0 — Privacy & Consent (tyk-privacy.js)

   Honors the Global Privacy Control signal (GPC) — required by California
   CPRA, Colorado, Connecticut, and increasingly other US state laws, and
   considered binding by EU DPAs as a withdrawal-of-consent indicator.

   Behavior:
     • If navigator.globalPrivacyControl === true on first load, set
       Shopify.customerPrivacy tracking consent to all-false BEFORE
       analytics or marketing pixels can fire.
     • Mark <html data-tyk-gpc="1"> so CSS can suppress the banner if a
       merchant prefers (some jurisdictions still require the banner —
       opt-out signal alone isn't always enough).
     • Always persistent — re-applies on every page load even after the
       customer has been here before.

   Loaded in the <head> with no defer, BEFORE any analytics scripts, so
   the consent state is set before tracking pixels make any decisions.
   ───────────────────────────────────────────────────────────────────── */

(function () {
  'use strict';

  // 1) Mark the GPC signal on the document for CSS / analytics to inspect.
  var gpc = false;
  try {
    gpc = navigator.globalPrivacyControl === true;
  } catch (e) { /* old browsers — gpc stays false */ }

  if (gpc) {
    try { document.documentElement.setAttribute('data-tyk-gpc', '1'); } catch (e) {}
  }

  // 2) Apply consent to Shopify's Customer Privacy API as soon as it loads.
  //    Shopify lazy-loads this — we register an interval that polls briefly
  //    and applies once available, then stops.
  function applyConsent(consent) {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return false;
    try {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, function (err) {
        // Silent — we don't surface storage errors to the customer.
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function denyConsent() {
    return applyConsent({
      analytics: false,
      marketing: false,
      preferences: false,
      sale_of_data: false,
    });
  }

  if (gpc) {
    // First try synchronously
    var applied = denyConsent();
    if (!applied) {
      // Poll every 200ms for up to 4s for Shopify.customerPrivacy to load
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (denyConsent() || tries >= 20) clearInterval(iv);
      }, 200);
    }
  }

  // 3) Also listen for Shopify's privacyApiReady event — guarantees we
  //    apply consent the moment the API is available, even on slow
  //    connections where polling might miss the window.
  document.addEventListener('shopify:privacy_api_ready', function () {
    if (gpc) denyConsent();
  });

  // 4) Public hook — small helper merchants/devs can use elsewhere.
  window.tykPrivacy = {
    isGpcActive: function () { return gpc; },
    denyAll: denyConsent,
    apply: applyConsent,
  };
})();
